import React from 'react';
import {Image, ImageStyle, StyleProp} from 'react-native';

// Design-handoff image assets (design_handoff_player_profile_5/assets). On web,
// react-native-web resolves a `.svg` import to a URL, so we render it through
// <Image> -- the browser rasterizes the full SVG (masks, gradients and all) at
// full fidelity, which the react-native-svg web build can't guarantee for those
// features. The mobile repo has a sibling ProfileAsset that renders the same
// assets as react-native-svg-transformer components. Same public API in both.
import goldMedal from '@/Assets/Images/PlayerProfile/goldMedal.svg';
import silverMedal from '@/Assets/Images/PlayerProfile/silverMedal.svg';
import bronzeMedal from '@/Assets/Images/PlayerProfile/bronzeMedal.svg';
import tournament from '@/Assets/Images/PlayerProfile/tournament.svg';
import assessment from '@/Assets/Images/PlayerProfile/assessment.svg';
import gameAnalytics from '@/Assets/Images/PlayerProfile/game_analytics.svg';
import fourSquares from '@/Assets/Images/PlayerProfile/four_squares.svg';
import pattern from '@/Assets/Images/PlayerProfile/pattern.svg';
import coin from '@/Assets/Images/PlayerProfile/coin.svg';
import ccIcon from '@/Assets/Images/PlayerProfile/cc-icon.svg';
import caissaGirl from '@/Assets/Images/PlayerProfile/caissa-girl.svg';

const ASSETS = {
  goldMedal,
  silverMedal,
  bronzeMedal,
  tournament,
  assessment,
  gameAnalytics,
  fourSquares,
  pattern,
  coin,
  ccIcon,
  caissaGirl,
} as const;

export type ProfileAssetName = keyof typeof ASSETS;

type Props = {
  name: ProfileAssetName;
  // Square shorthand; use width/height to override per axis.
  size?: number;
  width?: number;
  height?: number;
  style?: StyleProp<ImageStyle>;
};

export default function ProfileAsset({
  name,
  size = 24,
  width,
  height,
  style,
}: Props) {
  return (
    <Image
      source={ASSETS[name]}
      resizeMode="contain"
      style={[{width: width ?? size, height: height ?? size}, style]}
    />
  );
}
